import { IconBug, IconHome2, IconMail, IconSoccerField, IconTag, IconUser, IconFileReport, IconSettings, IconDatabaseImport, IconReceipt, IconCategory, IconRun, IconFileInvoice, IconShoppingCart, IconContract, IconToolsKitchen2, IconList, IconUsersGroup, IconId, IconWallet, IconChartBar, IconFileExport, IconUserSearch, IconBox, IconMapPin, IconArrowsExchange, IconKey, IconShieldSearch, IconCalendarEvent } from '@tabler/icons-react';
import { NavLink } from '@mantine/core';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUserContext } from '../providers/UserContext.tsx';
import { useLanguage } from '../providers/LanguageContext.tsx';
import { USER_RIGHTS } from '../constants/userRights.ts';

function NavigationItems({ onNavigate }: { onNavigate?: () => void }) {
    const location = useLocation();
    const navigate = useNavigate();
    const { userRights, userRightsLoading } = useUserContext();
    const { t } = useLanguage();

    if (userRightsLoading) return null;

    const isActive = (href: string) => location.pathname === href;
    const startsWith = (prefix: string) => location.pathname.startsWith(prefix);

    const isAdmin     = userRights.includes(USER_RIGHTS.ADMIN);
    const hasPersons  = userRights.includes(USER_RIGHTS.PERSONS);
    const hasContracts = userRights.includes(USER_RIGHTS.CONTRACTS);
    const hasAccounting = userRights.includes(USER_RIGHTS.ACCOUNTING);
    const hasInvoices = userRights.includes(USER_RIGHTS.INVOICES);
    const hasMatches  = userRights.includes(USER_RIGHTS.MATCHES);
    const hasRestaurant = userRights.includes(USER_RIGHTS.RESTAURANT);
    const hasTraining = userRights.includes(USER_RIGHTS.TRAINING);
    const hasMessages = userRights.includes(USER_RIGHTS.MESSAGES);
    const hasTags     = userRights.includes(USER_RIGHTS.TAGS);
    const hasDrafts   = userRights.includes(USER_RIGHTS.DRAFTS);
    const isExternal  = userRights.includes(USER_RIGHTS.EXTERNAL);
    const hasInventory = userRights.includes(USER_RIGHTS.INVENTORY);
    const hasAudit    = userRights.includes(USER_RIGHTS.AUDIT);

    const bookingActive = isActive('/booking') || startsWith('/booking/') || startsWith('/calculation');
    const matchActive = startsWith('/match') || startsWith('/matchdata') || startsWith('/match/stats');

    const nav = (href: string) => { navigate(href); onNavigate?.(); };

    if (isExternal) {
        return (
            <>
                <NavLink label={t.nav.home} leftSection={<IconHome2 size="1rem" stroke={1.5} />} active={isActive('/')} onClick={() => nav('/')} />
                {hasMessages && (
                    <NavLink label={t.nav.messages} leftSection={<IconMail size="1rem" stroke={1.5} />} active={isActive('/messages')} onClick={() => nav('/messages')} />
                )}
                {hasRestaurant && (
                    <NavLink
                        label="Restaurant"
                        leftSection={<IconToolsKitchen2 size="1rem" stroke={1.5} />}
                        childrenOffset={28}
                        defaultOpened={startsWith('/restaurant')}
                        active={startsWith('/restaurant')}
                    >
                        <NavLink label="Kasse" leftSection={<IconToolsKitchen2 size="1rem" stroke={1.5} />} active={isActive('/restaurant')} onClick={() => nav('/restaurant')} />
                        <NavLink label="Aufträge" leftSection={<IconList size="1rem" stroke={1.5} />} active={isActive('/restaurant/orders')} onClick={() => nav('/restaurant/orders')} />
                        <NavLink label={t.nav.restaurantStock} leftSection={<IconBox size="1rem" stroke={1.5} />} active={isActive('/restaurant/stock')} onClick={() => nav('/restaurant/stock')} />
                    </NavLink>
                )}
                <NavLink label={t.nav.myProfile} leftSection={<IconId size="1rem" stroke={1.5} />} active={isActive('/member/profile')} onClick={() => nav('/member/profile')} />
                <NavLink label={t.nav.myAccount} leftSection={<IconWallet size="1rem" stroke={1.5} />} active={isActive('/member/account')} onClick={() => nav('/member/account')} />
            <NavLink label={t.nav.myCalendar} leftSection={<IconCalendarEvent size="1rem" stroke={1.5} />} active={isActive('/member/calendar')} onClick={() => nav('/member/calendar')} />
                <NavLink label={t.nav.myCalendar} leftSection={<IconCalendarEvent size="1rem" stroke={1.5} />} active={isActive('/member/calendar')} onClick={() => nav('/member/calendar')} />
            </>
        );
    }

    return (
        <>
            <NavLink label={t.nav.home} leftSection={<IconHome2 size="1rem" stroke={1.5} />} active={isActive('/')} onClick={() => nav('/')} />

            {hasPersons && (
                <NavLink label={t.nav.persons} leftSection={<IconUser size="1rem" stroke={1.5} />} active={isActive('/person')} onClick={() => nav('/person')} />
            )}

            {hasContracts && (
                <NavLink label={t.nav.contracts} leftSection={<IconContract size="1rem" stroke={1.5} />} active={startsWith('/contract')} onClick={() => nav('/contract')} />
            )}

            {hasAccounting && (
                <NavLink label={t.nav.booking} leftSection={<IconBug size="1rem" stroke={1.5} />} childrenOffset={28} defaultOpened={bookingActive} active={bookingActive}>
                    <NavLink label={t.nav.bookings} leftSection={<IconBug size="1rem" stroke={1.5} />} active={isActive('/booking')} onClick={() => nav('/booking')} />
                    <NavLink label={t.nav.receipts} leftSection={<IconReceipt size="1rem" stroke={1.5} />} active={startsWith('/receipt')} onClick={() => nav('/receipt')} />
                    {/* <NavLink label={t.nav.accountReport} leftSection={<IconFileReport size="1rem" stroke={1.5} />} active={isActive('/booking/report')} onClick={() => nav('/booking/report')} /> */}
                    <NavLink label={t.nav.paymentsReport} leftSection={<IconFileReport size="1rem" stroke={1.5} />} active={isActive('/booking/report/summary')} onClick={() => nav('/booking/report/summary')} />
<NavLink label={t.nav.bookingTypes} leftSection={<IconCategory size="1rem" stroke={1.5} />} active={startsWith('/bookingtype')} onClick={() => nav('/bookingtype')} />
                    <NavLink label="PRAE (L19 Export)" leftSection={<IconFileExport size="1rem" stroke={1.5} />} active={isActive('/prae')} onClick={() => nav('/prae')} />
                </NavLink>
            )}

            {hasInvoices && (
                <NavLink
                    label={t.nav.invoices}
                    leftSection={<IconFileInvoice size="1rem" stroke={1.5} />}
                    childrenOffset={28}
                    defaultOpened={startsWith('/invoice') || startsWith('/article')}
                    active={startsWith('/invoice') || startsWith('/article')}
                >
                    <NavLink label={t.nav.invoiceList} leftSection={<IconFileInvoice size="1rem" stroke={1.5} />} active={isActive('/invoice')} onClick={() => nav('/invoice')} />
                    <NavLink label={t.nav.articles} leftSection={<IconShoppingCart size="1rem" stroke={1.5} />} active={startsWith('/article')} onClick={() => nav('/article')} />
                </NavLink>
            )}

            {hasMatches && (
                <NavLink label={t.nav.match} leftSection={<IconSoccerField size="1rem" stroke={1.5} />} childrenOffset={28} defaultOpened={matchActive} active={matchActive}>
                    <NavLink label={t.nav.matchOverview} leftSection={<IconSoccerField size="1rem" stroke={1.5} />} active={isActive('/match')} onClick={() => nav('/match')} />
                    <NavLink label={t.nav.matchStats} leftSection={<IconChartBar size="1rem" stroke={1.5} />} active={isActive('/match/stats')} onClick={() => nav('/match/stats')} />
                    <NavLink label={t.nav.loadMatchdata} leftSection={<IconDatabaseImport size="1rem" stroke={1.5} />} active={isActive('/matchdata')} onClick={() => nav('/matchdata')} />
                    <NavLink label={t.nav.playerIdMatching} leftSection={<IconUserSearch size="1rem" stroke={1.5} />} active={isActive('/matchdata/player-ids')} onClick={() => nav('/matchdata/player-ids')} />
                </NavLink>
            )}

            {hasRestaurant && (
                <NavLink
                    label="Restaurant"
                    leftSection={<IconToolsKitchen2 size="1rem" stroke={1.5} />}
                    childrenOffset={28}
                    defaultOpened={startsWith('/restaurant')}
                    active={startsWith('/restaurant')}
                >
                    <NavLink label="Kasse" leftSection={<IconToolsKitchen2 size="1rem" stroke={1.5} />} active={isActive('/restaurant')} onClick={() => nav('/restaurant')} />
                    <NavLink label="Aufträge" leftSection={<IconList size="1rem" stroke={1.5} />} active={isActive('/restaurant/orders')} onClick={() => nav('/restaurant/orders')} />
                        <NavLink label={t.nav.restaurantStock} leftSection={<IconBox size="1rem" stroke={1.5} />} active={isActive('/restaurant/stock')} onClick={() => nav('/restaurant/stock')} />
                </NavLink>
            )}

            {hasTraining && (
                // <NavLink
                //     label={t.nav.training}
                //     leftSection={<IconRun size="1rem" stroke={1.5} />}
                //     childrenOffset={28}
                //     defaultOpened={startsWith('/training/')}
                //     active={startsWith('/training/')}
                // >
                    <NavLink label={t.nav.trainingEvents} leftSection={<IconRun size="1rem" stroke={1.5} />} active={startsWith('/training/events')} onClick={() => nav('/training/events')} />
                // </NavLink>
            )}

            {hasInventory && (
                <NavLink label={t.nav.inventory} leftSection={<IconBox size="1rem" stroke={1.5} />} childrenOffset={28} defaultOpened={startsWith('/inventory')} active={startsWith('/inventory')}>
                    <NavLink label={t.nav.inventoryStock} leftSection={<IconBox size="1rem" stroke={1.5} />} active={isActive('/inventory') || startsWith('/inventory/article')} onClick={() => nav('/inventory')} />
                    <NavLink label={t.nav.inventoryRentals} leftSection={<IconArrowsExchange size="1rem" stroke={1.5} />} active={isActive('/inventory/rentals') && !location.search.includes('category=')} onClick={() => nav('/inventory/rentals')} />
                    <NavLink label={t.nav.inventoryKeys} leftSection={<IconKey size="1rem" stroke={1.5} />} active={isActive('/inventory/rentals') && location.search.includes('category=')} onClick={() => nav('/inventory/rentals?category=Schl%C3%BCssel')} />
                    <NavLink label={t.nav.inventoryLocations} leftSection={<IconMapPin size="1rem" stroke={1.5} />} active={isActive('/inventory/locations')} onClick={() => nav('/inventory/locations')} />
                </NavLink>
            )}

            {hasMessages && (
                <NavLink label={t.nav.messages} leftSection={<IconMail size="1rem" stroke={1.5} />} active={isActive('/messages')} onClick={() => nav('/messages')} />
            )}

            {hasTags && (
                <NavLink label={t.nav.tags} leftSection={<IconTag size="1rem" stroke={1.5} />} active={isActive('/tag')} onClick={() => nav('/tag')} />
            )}

            {hasDrafts && (
                <NavLink label={t.nav.drafts} leftSection={<IconUsersGroup size="1rem" stroke={1.5} />} active={startsWith('/drafts')} onClick={() => nav('/drafts')} />
            )}

            <NavLink label={t.nav.myProfile} leftSection={<IconId size="1rem" stroke={1.5} />} active={isActive('/member/profile')} onClick={() => nav('/member/profile')} />
            <NavLink label={t.nav.myAccount} leftSection={<IconWallet size="1rem" stroke={1.5} />} active={isActive('/member/account')} onClick={() => nav('/member/account')} />

            {hasAudit && (
                <NavLink label={t.nav.audit} leftSection={<IconShieldSearch size="1rem" stroke={1.5} />} active={isActive('/audit')} onClick={() => nav('/audit')} />
            )}

            {isAdmin && (
                <NavLink label={t.nav.admin} leftSection={<IconSettings size="1rem" stroke={1.5} />} active={isActive('/admin') || startsWith('/payment-account')} onClick={() => nav('/admin')} />
            )}
        </>
    );
}

export default NavigationItems;
